export default "__VITE_ASSET__Cnz9Uouj__"